var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contents)?_c('div',{staticClass:"mark-down-sb",domProps:{"innerHTML":_vm._s(_vm.sanitizedMarkdown)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }